import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './modules/auth/pages/login';
import { AuthGuard } from './core/guards';
import { DashboardComponent } from './modules/dashboard/pages/dashboard/dashboard.component';
import { AppModuleRoutes } from '@app/app-routes';

export const routes: Routes = [

    { path: '', redirectTo: AppModuleRoutes.DASHBOARD, pathMatch: 'full' },
    { path: AppModuleRoutes.AUTH, component: LoginComponent, data: { hideToolbar: true, showFooter: true, showBanner: true } },
    { path: AppModuleRoutes.DASHBOARD, component: DashboardComponent, canActivate: [AuthGuard] },
    { path: '**', redirectTo: AppModuleRoutes.AUTH, pathMatch: 'full' }
];

export const routing = RouterModule.forRoot(routes, {});
